module.exports = __webpack_public_path__ + "img/zhxy_image_11.b5ae735e.png";